import React from 'react';
import { RouteContext } from 'src/context';
import { useRouteAccess } from 'src/routes/routeAccess';
import { PageContent } from 'src/legacy/components/UI';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';

export interface PageLayoutProps {
  routeAccessCheck?: keyof ReturnType<typeof useRouteAccess>;
  noToolbar?: boolean;
  fullpage?: boolean;
  noSpace?: boolean;
  unauthAccessAllowed?: boolean | keyof ReturnType<typeof useRouteAccess>;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  routeAccessCheck,
  children,
  noToolbar = false,
  fullpage = false,
  noSpace = false,
  unauthAccessAllowed = false,
}) => {
  const routeAccess = useRouteAccess();
  const drawerWidth = useDrawerWidth();
  const { pathname } = React.useContext(RouteContext);
  const isSettingsPage = pathname.startsWith('/settings');
  const allowed = routeAccessCheck ? routeAccess[routeAccessCheck] : undefined;
  const unauthAccessAllowedBool =
    typeof unauthAccessAllowed === 'string'
      ? routeAccess[unauthAccessAllowed]
      : unauthAccessAllowed;
  return (
    <PageContent
      drawerWidth={drawerWidth}
      allowed={allowed}
      noToolbar={noToolbar}
      fullPage={fullpage}
      noSpace={noSpace}
      isSettingsPage={isSettingsPage}
      unauthAccessAllowed={unauthAccessAllowedBool}
    >
      {children}
    </PageContent>
  );
};
